import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { withRouter } from 'react-router-dom';

import AuthService from '../services/AuthService';
import { auth } from '../services/api';

interface Props {
  token?: string;
  dashboard: Function;
  monthly: Function;
  location: any;
  match: any;
  history: any;
  redirect?: any;
}

class OneTimeToken extends React.Component<Props, {}> {
  componentDidMount() {
    const token = this.props.location.search.substring(7);
    AuthService.setToken(token);
    auth
      .oneTimeToken(token)
      .then((res: any) => {
        AuthService.setToken(res.token);
        if (this.props.redirect === 'monthly') this.props.monthly();
        else this.props.dashboard();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    return <p>Logging In...</p>;
  }
}

export default withRouter(
  connect(null, { dashboard: () => push('/'), monthly: () => push('/results') })(OneTimeToken)
);
